export function formatString(name, size) {
  if (name && name.length <= size) {
    return name;
  }
  return name && name.substring(0, size).concat("...");
}
